import React, { Fragment } from "react";
import PropTypes from "prop-types";

const options = {
  newWindow: "newWindow",
  email: "email",
  phone: "phone",
  pdf: "pdf",
};

let ariaLabelSuffix = {
  [options.newWindow]: "in a new window",
  [options.email]: "email",
  [options.phone]: "phone",
  [options.pdf]: "PDF",
};

let iconCSS = {
  [options.newWindow]: "icon-external-link",
  [options.email]: "icon-envelope",
  [options.phone]: "icon-phone",
  [options.pdf]: "icon-document-pdf",
};

function getLabelAndIcon(props) {
  const { href = "", pdf, target } = props;
  if (!href) {
    return false;
  }
  let type = options.web;
  const isExternal = target === "_blank";
  if (pdf) type = options.pdf;
  else if (href.startsWith("mailto:")) {
    type = options.email;
  } else if (href.startsWith("tel:")) {
    type = options.phone;
  } else if (isExternal) {
    type = options.newWindow;
  }
  const label = ariaLabelSuffix?.[type]
  return {
    icon: iconCSS?.[type],
    label: label ? `opens ${label}` : '',
  };
}

function Link(props = {}) {
  const { href, className, pdf, children, id: _id, ...rest } = props;
  let classN = `bux-link bux-button--icon`;
  if (className) classN += ` ${className}`;
  if (!href) {
    return false;
  }
  const { icon, label: ariaLabel } = getLabelAndIcon({
    href,
    pdf,
    target: rest?.target,
  });
  if (icon && ariaLabel) {
    const id = _id || crypto.randomUUID();
    const iconId = id + "-icon";
    return (
      <span className="footer-sup-icon-link-wrapper">
        <a
          id={id}
          aria-describedby={iconId}
          className={classN}
          href={href}
          {...rest}
        >
          {children}
        </a>
        <span
          id={iconId}
          aria-label={ariaLabel}
          className={`footer-sup-icon-link ${icon}`}
        />
      </span>
    );
  }
  return <a id={_id} className={classN} href={href} {...rest}>
    {children}
  </a>;
}

Link.propTypes = {
  href: PropTypes.string.isRequired,
};

export default Link;
